export const formValidatorTypes = {
    comproveForm: "[FormValidator] comprove schema",
    setSchema: "[FormValidator] setting Schema",
    removeSchema: "[FormValidator] removing Schema",
    setErrors: "[FormValidator] setting Errors",
    removeError: "[FormValidator] removing Errors",
    cleanFormValidator: "[FormValidator] clean Validator",
};
